const POS_PENDING_PAYMENT_WINDOW_MS = 90 * 1000;
const ONLINE_PENDING_PAYMENT_WINDOW_MS = 15 * 60 * 1000;

export const getOrderCheckout = (orderDetails?: { checkouts?: CashBoxCheckout[] | null } | null, checkoutId?: CashBoxId | null) => {
    if (!checkoutId) return null;

    return orderDetails?.checkouts?.find((checkout) => checkout.checkout_id === checkoutId) || null;
};

export const getPendingPaymentExpiresAt = (checkout?: Pick<CashBoxCheckout, "payment_type" | "payment_status" | "updated_at"> | null) => {
    if (!checkout || checkout.payment_status === "paid") {
        return 0;
    }

    const paymentWindowMs =
        checkout.payment_type === "pos"
            ? POS_PENDING_PAYMENT_WINDOW_MS :
        checkout.payment_type === "online"
            ? ONLINE_PENDING_PAYMENT_WINDOW_MS
            : 0;

    if (!paymentWindowMs) {
        return 0;
    }

    const updatedAtMs = new Date(checkout.updated_at).getTime();

    if (Number.isNaN(updatedAtMs)) {
        return 0;
    }

    return updatedAtMs + paymentWindowMs;
};

export const isPendingPaymentCheckout = (checkout?: Pick<CashBoxCheckout, "payment_type" | "payment_status" | "updated_at"> | null, nowMs = Date.now()) => {
    return getPendingPaymentExpiresAt(checkout) > nowMs;
};

export const isExpiredPendingPaymentCheckout = (checkout?: Pick<CashBoxCheckout, "payment_type" | "payment_status" | "updated_at"> | null, nowMs = Date.now()) => {
    const expiresAt = getPendingPaymentExpiresAt(checkout);
    return !!expiresAt && expiresAt <= nowMs;
};
